import { CreatureUI } from 'game/extended/uis/types/creature_uis'

import circle from './chicky_circle.png'
import head from './chicky_head.png'

export const chicky: CreatureUI = {
  label: 'Chicky',
  definition: lvl => ({
    stats: {
      health: 30,
      energy: 10,
      intelligence: 20,
      strength: 35,
      agility: 25,
      armor: 0,
      shielding: 0,
      resistance: 0
    },
    strategy: [
      'Punch'
    ],
    skills: [
    ]
  }),
  circle: {
    src: circle,
    width: 200,
    height: 150
  },
  head
}
